//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    "countTerm",
    "selectedCount",
    "countForm",
    "trademarkTypes",
    "searchCard",
    "pageName",
    "numberChecks",
    "typeChecks",
    "trademarkTP",
    "analysisJson",
    "edition", // simple是简易版本 highRank还是高级版本
    "filterWhere",
    "proposerInfoTxt",
    "agentTxt",
    "addressArrTxt",
    "countryTxt",
    "areaTxt",
    "cityTxt",
    "countyTxt"
  ],
  data() {
    return {
      noticeTypeShow: [],
      noticeTypeName: []
    };
  },
  watch: {
    typeChecks() {
      this.noticeTypeShow = this.trademarkTP.filter(tp =>
        this.typeChecks.find(fd => fd == tp.id)
      );
      this.noticeTypeName = this.noticeTypeShow.map(item => item.name);
    }
  },
  mounted() {},
  methods: {
    // 重置全部条件
    coloseAll() {
      console.log(this.pageName)
      this.pageName === "notice"
        ? this.rAdnSI("all", true)
        : this.rAdnSI("trademarkTypes", true);
      this.resetType();
      this.resetForm('all');
      this.resetSimpleType('all');
    },
    goTop() {
      let top = 0;
      let dom = document.getElementById("RightPlan");
      if (dom) {
        top = dom.scrollTop;
      } else {
        top = document.documentElement.scrollTop || document.body.scrollTop;
      }

      // 实现滚动效果
      const timeTop = setInterval(() => {
        if (dom) {
          dom.scrollTop = top -= 30;
        } else {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 30;
        }
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    showHideCard(type) {
      this.$emit("update:searchCard", !type);
    },
    resetType() {
      this.$emit("resetType");
    },
    rAdnSI(name, type) {
      // this.$emit("rAdnSI", 'trademarkTypes', true);
      this.$emit("rAdnSI", name, type);
    },
    resetForm(type) {
      console.log(22,type)
      this.$emit("resetForm", type);
      // if(this.edition === 'simple') this.resetSimpleType(type)
    },
    resetSimpleType(type){
      this.$emit("resetSimpleType", type);
    }
  },
  /*filters: {
    classTxt: function (arr) {
      // let _n = this.tools.autoZero(n, 2);
      let _arrNew = arr.map(item => this.tools.autoZero(item, 2))
      return _arrNew.join(',')
    }
  }*/
};
